import { Component, Input } from '@angular/core';
import { RevolupayService } from '../../services/revolupay.service';

@Component({
  selector: 'app-revolupay-user',
  standalone: false,
  templateUrl: './revolupay-user.component.html',
  styleUrl: './revolupay-user.component.css'
})
export class RevolupayUserComponent {
  @Input() uuid!: string;
  submitted = false;
  userInfo: any;
  addingAccess = false;

  constructor(
    private revolupayService: RevolupayService
  ) {}

  ngOnInit() {
    this.loadInfo();
  }

  loadInfo() {
    this.submitted = false; // show loader

    this.revolupayService.getInfo(this.uuid).subscribe(
      response => {
        this.userInfo = response; // store the data
        this.submitted = true;    // data loaded, show info
      },
      error => {
        console.error(error);
        this.submitted = true; // still hide loader even if failed
      }
    );
  }

  addAccess() {
    if (!this.uuid) return;

    this.addingAccess = true;

    this.revolupayService.addAccess(this.uuid).subscribe(
      response => {
        this.addingAccess = false;
        alert('Remittances access added successfully!');
        this.loadInfo();
      },
      error => {
        this.addingAccess = false;
        console.error('Failed to add access:', error);
      }
    );
  }

}
